export type ID = string;

export type PrefixedID = string;

export enum IDPrefixes {
  Tag = 'tag',
  LifeArea = 'lifeArea',
  Goal = 'goal',
  Task = 'task',
  Occurrence = 'occurrence',
  CompletedRow = 'completedRow',
  GoalDeadline = 'goalDeadline',
  NewTaskItem = 'newTaskItem',
  CalendarEvent = 'calendarEvent',
  MultiDayEvent = 'multiDayEvent',
}
